var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicDevice = function SvgMusicDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22,
    x: 5,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.225 13.656a.75.75 0 1 0-.39-1.449zm-5.439 1.464a.75.75 0 1 0-.383-1.45zm.55-6.862-.194-.724zm-1.707 7.627-.192-.725zm-.88.233-.191-.725zm-.305-1.154-.191-.725zm.497 1.879.88-.233-.384-1.45-.88.233zm2.404-2.212V9.224h-1.5v5.407zm.185-5.649 3.435-.92-.388-1.45-3.435.922zm3.75-.679v4.871h1.5v-4.87zm-.408 5.4-.882.234.383 1.45.883-.233zm-.802.533 2.155-.58-.39-1.449-2.155.58zm-3.667-.566-2.15.569.383 1.45 2.15-.569zm3.782.416c0 .07-.047.132-.115.15l-.39-1.448c-.587.158-.995.69-.995 1.298zm-.195-.15a.155.155 0 0 1 .195.15h-1.5c0 .883.835 1.526 1.688 1.3zm1.29-.762a.55.55 0 0 1-.408.53l.383 1.45a2.05 2.05 0 0 0 1.525-1.98zm-.315-5.112a.25.25 0 0 1 .315.241h1.5a1.75 1.75 0 0 0-2.203-1.69zm-3.62 1.162a.25.25 0 0 1 .185-.242l-.388-1.448a1.75 1.75 0 0 0-1.297 1.69zM9.82 16.61a2.05 2.05 0 0 0 1.525-1.979h-1.5a.55.55 0 0 1-.408.53zm-2.57-1.07c0 .884.837 1.529 1.69 1.303l-.382-1.45a.153.153 0 0 1 .192.148zm1.5 0c0 .07-.047.131-.114.149l-.383-1.45A1.35 1.35 0 0 0 7.25 15.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.75 2.25h4.5"
  })));
};
export default SvgMusicDevice;